import categoryList from './categorylist';

const productComponents = document.querySelectorAll('[data-product-id]');
const videoComponents = document.querySelectorAll('.media-component .video-wrapper');

categoryList();

if (productComponents) {
    import('./product').then(({default: loadProductComponents}) => loadProductComponents(productComponents));
}

if (videoComponents) {
    import('../../contentful/mediaVideo').then(({default: mediaVideo}) => mediaVideo.init(videoComponents));
}
